import React from "react";

const ChargebeeIframe = ({ url, onCLose, finishLoading }) => {
  return (
    <div className="chargebee-iframe" onClick={onCLose}>
      <iframe
        src={url}
        className="heylime-frame"
        title="GameApart Test"
        onLoad={finishLoading}
        onError={finishLoading}
      />
    </div>
  );
};

export default ChargebeeIframe;
